var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-d3',{staticClass:"overflow-hidden",attrs:{"onExportPng":_vm.handleExportPng,"showExport":_vm.showExport}},[_c('div',{ref:"vis-ref"})])}
var staticRenderFns = []

export { render, staticRenderFns }